import { slideDown, slideUp } from '../helpers/element/slide';

class Newsletter {
    constructor() {
        this.container = null;
        this.showTriggers = null;
        this.hideTriggers = null;
        this.isOpen = false;

        this.getElements();

        if (this.canInit()) {
            this.addEvents();
        }
    }

    /**
     * 
     */
    getElements() {
        this.container = document.querySelector('.newsletter--main');
        this.showTriggers = document.querySelectorAll('.js-newsletter-show');
        this.hideTriggers = document.querySelectorAll('.js-newsletter-hide');
    }

    /**
     * 
     */
    canInit() {
        return this.container !== null && this.showTriggers.length > 0 && this.hideTriggers.length > 0;
    }

    /**
     * 
     */
    addEvents() {
        this.showTriggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                event.preventDefault();
                this.showContainer();
            });
        });

        this.hideTriggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                event.preventDefault();

                this.hideContainer();
            });
        });
    }

    /**
     * 
     */
    showContainer() {
        if (!this.isOpen) {
            this.isOpen = true;
            slideDown(this.container);
        }
    }

    /**
     * 
     */
    hideContainer() {
        if (this.isOpen) {
            this.isOpen = false;
            slideUp(this.container);
        }
    }
}

new Newsletter(); // eslint-disable-line no-new
